export const FULCRUM_FORMS = {
  QualityPlans: 'e328b1d1-cd10-46d5-87d8-ace3f02a3344',
  DailyLogs: '1390d0f3-7363-470d-847f-7a4f393999d7',
  Prestarts: 'dfd98e4f-bfb0-46e9-bb82-7bd0784cbe80',
  Workshop: '3ebdfb67-0b99-40d2-b937-b91084a12457',
  Posts: 'b600af12-d5d0-4b5e-ade0-ef4f500e4171',
  Timesheets: '50038e62-4596-4da6-96e9-5650dc9964b7',
  Explosives: '3182eaff-898b-43dc-88df-d349913a2d99',
  Calendar: 'ff9b40a4-61e0-46fb-a592-48a8f90e2d4d',
}

export const FULCRUM_FORM_LABELS = {
  QualityPlans: 'Quality plans',
  DailyLogs: 'Daily logs',
  Prestarts: 'Prestarts',
  Workshop: 'Workshop records',
  Posts: 'Posts & updates',
  Timesheets: 'Timesheets',
  Explosives: 'Explosives inventory',
  Calendar: 'Calendar events',
}

// Fulcrum Query API column names (form field keys) for date/filter SQL.
export const FULCRUM_SQL_FIELDS = {
  Prestarts: {
    dateField: 'fdf9',
  },
  Workshop: {
    dateField: '4bc0',
    sheetTypeField: 'ef64',
    sheetTypeValue: 'Maintenance Sheet',
  },
}
